/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './insurance-claim.reducer';

export const InsuranceClaimDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const insuranceClaimEntity = useAppSelector(state => state.insuranceClaim.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="insuranceClaimDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.insuranceClaim.detail.title">InsuranceClaim</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.id">Id</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimEntity.id}</dd>
          <dt>
            <span id="claimCode">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.claimCode">Claim Code</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimEntity.claimCode}</dd>
          <dt>
            <span id="dateFrom">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.dateFrom">Date From</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimEntity.dateFrom}</dd>
          <dt>
            <span id="dateTo">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.dateTo">Date To</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimEntity.dateTo}</dd>
          <dt>
            <span id="adjustment">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.adjustment">Adjustment</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimEntity.adjustment}</dd>
          <dt>
            <span id="claimedTotal">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.claimedTotal">Claimed Total</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimEntity.claimedTotal}</dd>
          <dt>
            <span id="approvedTotal">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.approvedTotal">Approved Total</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimEntity.approvedTotal}</dd>
          <dt>
            <span id="dateProcessed">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.dateProcessed">Date Processed</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimEntity.dateProcessed}</dd>
          <dt>
            <span id="explanation">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.explanation">Explanation</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimEntity.explanation}</dd>
          <dt>
            <span id="rejectionReason">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.rejectionReason">Rejection Reason</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimEntity.rejectionReason}</dd>
          <dt>
            <span id="guaranteeId">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.guaranteeId">Guarantee Id</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimEntity.guaranteeId}</dd>
          <dt>
            <span id="externalId">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.externalId">External Id</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimEntity.externalId}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.type">Type</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimEntity.type}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.status">Status</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimEntity.status}</dd>
          <dt>
            <span id="paymentStatus">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.paymentStatus">Payment Status</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimEntity.paymentStatus}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.active">Active</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>
            {insuranceClaimEntity.microSec ? (
              <TextFormat value={insuranceClaimEntity.microSec} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>
            {insuranceClaimEntity.timestampEntry ? (
              <TextFormat value={insuranceClaimEntity.timestampEntry} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>
            {insuranceClaimEntity.lastUpdated ? (
              <TextFormat value={insuranceClaimEntity.lastUpdated} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.insuranceClaim.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.insuranceClaim.policy">Policy</Translate>
          </dt>
          <dd>{insuranceClaimEntity.policy ? insuranceClaimEntity.policy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.insuranceClaim.patient">Patient</Translate>
          </dt>
          <dd>{insuranceClaimEntity.patient ? insuranceClaimEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.insuranceClaim.location">Location</Translate>
          </dt>
          <dd>{insuranceClaimEntity.location ? insuranceClaimEntity.location.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.insuranceClaim.bill">Bill</Translate>
          </dt>
          <dd>{insuranceClaimEntity.bill ? insuranceClaimEntity.bill.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/insurance-claim" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/insurance-claim/${insuranceClaimEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default InsuranceClaimDetail;
